export default __webpack_public_path__ + "static/media/pcb.41a14e48.png";